var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoaded)?_c('spinner'):_c('div',[_c('prd-grid-wrapper',{attrs:{"data-items":_vm.memberOverviewData,"columns":_vm.memberResultColumns,"row-height":34}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }